import GLightbox from 'glightbox';

document.addEventListener('DOMContentLoaded', function () {
    const btn = document.querySelector('.gallery__button');
    const gallery = document.querySelector('.gallery__masonry');
    const galleryImagesContainer = gallery?.querySelector('.gallery__images');

    if (!btn || !gallery || !galleryImagesContainer) return;

    const all_images = parseInt(gallery.getAttribute('data-max-img'), 10);
    const postId = gallery.dataset.postId;
    const button_text = btn.getAttribute('data-btn-text');

    let offset = 12;
    let allLoaded = false;
    const loadStep = 3;

    const lightbox = GLightbox({
        selector: '.glightbox'
    });

    btn.addEventListener('click', function () {
        // Ako su sve slike već učitane – "Učitaj manje"
        if (allLoaded) {
            const allItems = galleryImagesContainer.querySelectorAll('.gallery__image-wrapper');
            allItems.forEach((item, index) => {
                if (index >= 12) {
                    item.remove();
                }
            });

            offset = 12;
            allLoaded = false;
            btn.textContent = button_text;

            lightbox.reload();

            // ✅ Scroll da dugme bude u dnu ekrana
            btn.scrollIntoView({ behavior: 'smooth', block: 'end' });

            return;
        }

        // AJAX učitavanje dodatnih slika
        fetch(ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: 'load_more_gallery_images',
                post_id: postId,
                offset: offset
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success && data.data.html) {
                galleryImagesContainer.insertAdjacentHTML('beforeend', data.data.html);
                offset += loadStep;
                lightbox.reload();

                const newImages = galleryImagesContainer.querySelectorAll('.js-animate-on-load:not(.animate-rotate)');
                newImages.forEach((img, index) => {
                  img.classList.add('animate-rotate');
                });

                if (offset >= all_images) {
                    btn.textContent = 'Ucitaj manje';
                    allLoaded = true;
                }

                // ✅ Scroll da dugme bude u dnu ekrana
                btn.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else {
                btn.remove();
            }
        });
    });
});
